module.exports = __webpack_public_path__ + "img/app-item-upload-dark.ce040bd7.svg";